import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DataService } from '@providers/common/data.service';

@Injectable({
  providedIn: 'root'
})
export class DataResolverService  {
  private dataService = inject(DataService);


  resolve(route: ActivatedRouteSnapshot) {
    const id: number | string = route.paramMap.get('id');
    return this.dataService.getData(id);
  }
}
